import "./styles/index.scss";
import _Button from "./components/Button";
import _Pagination from "./components/Pagination";
import _TextField from "./components/Input/TextField";
import _Select from "./components/Input/Select";
import _Check from "./components/Input/Check";
import _Avatar from "./components/Avatar";
import _Icon from "./components/Icon";
import _Overlay from "./components/Overlay";
import _TableExtend from "./components/Table";

export const Button = _Button;
export const Pagination = _Pagination;
export const TextField = _TextField;
export const Select = _Select;
export const Check = _Check;
export const Avatar = _Avatar;
export const Icon = _Icon;
export const Overlay = _Overlay;
export const TableExtend = _TableExtend;
